import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "ts modal-wrapper"
};
const _hoisted_2 = {
  class: "ts modal wider"
};
const _hoisted_3 = {
  class: "header-row"
};
const _hoisted_4 = {
  novalidate: "",
  name: "createDistribution"
};
const _hoisted_5 = {
  class: "split-content small-top-margin"
};
const _hoisted_6 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_7 = {
  class: "flex justify-between px-8 pb-8 mt-8"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock("svg", {
    onClick: _cache[0] || (_cache[0] = $event => $setup.distributionNavigationStore.toggleUpdateDistributionModal(false, null)),
    width: "14",
    height: "14",
    class: "close-btn",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [...(_cache[4] || (_cache[4] = [_createElementVNode("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#727272"
  }, [_createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2"
  }), _createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
  })], -1)]))])), _createElementVNode("h1", null, [_withDirectives(_createElementVNode("span", null, "Create Distribution", 512), [[_vShow, !$setup.distribution?.id]]), _withDirectives(_createElementVNode("span", null, "Edit Distribution", 512), [[_vShow, $setup.distribution?.id]])])]), _createElementVNode("form", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("label", _hoisted_6, [_cache[5] || (_cache[5] = _createTextVNode(" Label ", -1)), _withDirectives(_createElementVNode("input", {
    type: "text",
    name: "label",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.distribution = $event)
  }, null, 512), [[_vModelText, $setup.distribution]])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_LlSecondaryButton, {
    onClick: _cache[2] || (_cache[2] = $event => $setup.distributionNavigationStore.toggleUpdateDistributionModal(false, null))
  }, {
    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Cancel ", -1)]))]),
    _: 1
  }), _createVNode(_component_LlSecondaryButton, {
    color: "primary",
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $setup.confirm($setup.distributionNavigationStore.type), ["prevent"]))
  }, {
    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Save ", -1)]))]),
    _: 1
  })])])])]);
}